// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0369fe1f","520":"f19b24de","649":"1749eeee","892":"429c0c82"}[chunkId] + ".chunk.js";
};